module.exports = __webpack_public_path__ + "img/yen.134076d2.png";